import TextLink from './TextLink';

export * from './TextLink';
export default TextLink;
